/**
 *  [2023] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * 組織単位で案件を管理するDBの使い方をサポートするキャッシュ機能
 *  caseBasedDataManagementを拡張する
 */

import {Dexie} from 'dexie';
import {BaseDbStructure, classInit, newLocalStorageAdapter} from '@zettant/cacheManage';
import {MultiOrgCaseDataManage} from './multiOrgCaseBasedDataManageClass';


const DB_VERSION = 1;


const initDbAndTables = (tableName: string, version=DB_VERSION): BaseDbStructure => {
  const db = new Dexie(tableName);
  db.version(version).stores({
    entries: '[caseId+dataId]',
    meta: 'name',
    media: 'filePath,lastAccessedAt',
  });
  return {
    // @ts-ignore
    db,
    entries: (db as any).entries,
    meta: (db as any).meta,
    media: (db as any).media,
  };
};

const initLocalStorageTables = (tableName: string, version = DB_VERSION): BaseDbStructure => (
  {
    db: {
      open: () => {
      },
      delete: () => {
      },
    } as any,
    entries: newLocalStorageAdapter(tableName, 'entries', 'caseId', 'dataId') as any,
    meta: newLocalStorageAdapter(tableName, 'meta', 'name') as any,
    media: newLocalStorageAdapter(tableName, 'media', 'filePath') as any,
  } as BaseDbStructure
);

const init = async (tableName: string, email?: string, localStorageMode=false): Promise<MultiOrgCaseDataManage> => {
  let cache: MultiOrgCaseDataManage;
  if (!localStorageMode) {
    cache = new MultiOrgCaseDataManage(tableName, initDbAndTables, undefined, DB_VERSION);
  } else {
    cache = new MultiOrgCaseDataManage(tableName, initLocalStorageTables, undefined, DB_VERSION);
  }
  const db = cache.getDb();
  try {
    await db.db.open();
  } catch (d) {
    await db.db.delete(); // 何かおかしいので、一度キャッシュを削除して作り直す
    if (!localStorageMode) {
      cache = new MultiOrgCaseDataManage(tableName, initDbAndTables, undefined, DB_VERSION);
    } else {
      cache = new MultiOrgCaseDataManage(tableName, initLocalStorageTables, undefined, DB_VERSION);
    }
  }
  await classInit<MultiOrgCaseDataManage>(cache, tableName, 'caseId', 'dataId', email);

  return cache;
};


export {init, DB_VERSION};
